// src/pages/Home/components/Navbar3/components/NavbarActions.jsx

import React from "react";

import {
  FaCalendarCheck,
  FaCog,
  FaEnvelope,
  FaSignInAlt,
  FaUserPlus,
  FaVoteYea,
} from "react-icons/fa";

import { MdOutlineMessage } from "react-icons/md";

import HeaderIconButton from "../ui/HeaderIconButton";
import ThemeToggle from "../ui/ThemeToggle";

import {
  ALL_CONNECTED_ROLES,
  CONVOCATION_ROLES,
  MESSAGE_ROLES,
} from "../data/navbar3.data";

import { cx } from "../utils/navbar3.utils";

export default function NavbarActions({
  variant = "desktop",

  user,
  userRoleId,

  badgeCounts,

  pendingVotesLoading,
  loadingConvocations,

  canAccessConvocations,
  hasAccessToItem,

  isDarkMode,

  handleNavigation,
  toggleTheme,
}) {
  const isMobile =
    variant === "mobile";

  const iconClassName = isMobile
    ? "text-sm"
    : "text-base md:text-lg";

  const canAccessMessages =
    hasAccessToItem(MESSAGE_ROLES);

  return (
    <div
      className={cx(
        "flex items-center",
        isMobile
          ? [
              "h-full w-full",
              "justify-evenly",
              "gap-1",
              "overflow-x-auto",
              "px-2",
              "overscroll-x-contain",
              "[scrollbar-width:none]",
              "[&::-webkit-scrollbar]:hidden",
            ].join(" ")
          : [
              "shrink-0",
              "gap-1",
              "lg:gap-2",
            ].join(" "),
      )}
    >
      {user ? (
        <>
          {canAccessMessages ? (
            <HeaderIconButton
              variant={variant}
              label="Vos messages privés"
              count={badgeCounts.messages}
              onClick={() =>
                handleNavigation(
                  "/messagerie",
                  MESSAGE_ROLES,
                )
              }
            >
              <FaEnvelope
                className={iconClassName}
              />
            </HeaderIconButton>
          ) : null}

          {canAccessConvocations ? (
            <HeaderIconButton
              variant={variant}
              label={
                badgeCounts.convocations > 0
                  ? `${badgeCounts.convocations} convocation${
                      badgeCounts.convocations > 1
                        ? "s"
                        : ""
                    } en attente`
                  : "Mes convocations"
              }
              count={
                badgeCounts.convocations
              }
              onClick={() =>
                handleNavigation(
                  "/mesconvocations",
                  CONVOCATION_ROLES,
                )
              }
            >
              <FaCalendarCheck
                className={cx(
                  iconClassName,

                  badgeCounts.convocations > 0
                    ? "text-yellow-300"
                    : "text-white",

                  loadingConvocations
                    ? "animate-pulse"
                    : "",
                )}
              />
            </HeaderIconButton>
          ) : null}

          <HeaderIconButton
            variant={variant}
            label={
              badgeCounts.votes > 0
                ? `${badgeCounts.votes} vote${
                    badgeCounts.votes > 1
                      ? "s"
                      : ""
                  } en attente`
                : "Votes électroniques"
            }
            count={badgeCounts.votes}
            onClick={() =>
              handleNavigation(
                "/votes-utilisateur",
                ALL_CONNECTED_ROLES,
              )
            }
          >
            <FaVoteYea
              className={cx(
                iconClassName,

                badgeCounts.votes > 0
                  ? "text-amber-300"
                  : "text-white",

                pendingVotesLoading
                  ? "animate-pulse"
                  : "",
              )}
            />
          </HeaderIconButton>

          {userRoleId === 1 ? (
            <>
              <HeaderIconButton
                variant={variant}
                label="Messages du formulaire"
                count={
                  badgeCounts.contactForms
                }
                onClick={() =>
                  handleNavigation(
                    "/appli/dashboard",
                  )
                }
              >
                <MdOutlineMessage
                  className={
                    isMobile
                      ? "text-base"
                      : "text-lg"
                  }
                />
              </HeaderIconButton>

              <HeaderIconButton
                variant={variant}
                label="Tableau de bord administratif"
                onClick={() =>
                  handleNavigation(
                    "/appli/dashboard",
                  )
                }
              >
                <FaCog
                  className={iconClassName}
                />
              </HeaderIconButton>
            </>
          ) : null}
        </>
      ) : (
        <>
          <HeaderIconButton
            variant={variant}
            label="Créer un compte"
            onClick={() =>
              handleNavigation(
                "/register",
              )
            }
            className="
              bg-blueprimary
              hover:bg-blueprimarylight
            "
          >
            <FaUserPlus
              className={iconClassName}
            />
          </HeaderIconButton>

          <HeaderIconButton
            variant={variant}
            label="Connexion"
            onClick={() =>
              handleNavigation(
                "/login",
              )
            }
            className="
              bg-blueprimary
              hover:bg-blueprimarylight
            "
          >
            <FaSignInAlt
              className={iconClassName}
            />
          </HeaderIconButton>
        </>
      )}

      <ThemeToggle
        variant={variant}
        isDarkMode={isDarkMode}
        onToggle={toggleTheme}
      />
    </div>
  );
}